import _extends from "@babel/runtime/helpers/extends";
import React, { memo, useContext } from 'react';
import { Checkbox } from "../../form";
import { DropdownContext } from "../../form/select/dropdown/DropdownContext";
import { Row } from "../../layout";
import { ScreenReaderOnly } from "../../screen-reader-only";
import { StyledDropdownLi } from "./helperComponents";
import { jsx as ___EmotionJSX } from "@emotion/core";

var DropdownCustomLi = function DropdownCustomLi(_ref) {
  var getItemProps = _ref.getItemProps,
      isHighlighted = _ref.isHighlighted,
      _ref$item = _ref.item,
      checked = _ref$item.checked,
      label = _ref$item.label,
      onClick = _ref$item.onClick,
      index = _ref.index;

  var _useContext = useContext(DropdownContext),
      selectedOptionAltText = _useContext.selectedOptionAltText;

  return ___EmotionJSX(StyledDropdownLi, _extends({
    "aria-describedby": "group-selection-label",
    isHighlighted: isHighlighted,
    withCustomSelectionOptions: true
  }, !!getItemProps ? getItemProps({
    item: label,
    index: index
  }) : {}, {
    onClick: onClick
  }), ___EmotionJSX(Row, {
    alignItems: "center",
    gridGap: "S200"
  }, ___EmotionJSX(Checkbox, {
    checked: checked,
    id: label,
    onChange: function onChange() {
      return null;
    },
    value: label
  }), checked && ___EmotionJSX(ScreenReaderOnly, null, selectedOptionAltText, ", "), label));
};

DropdownCustomLi.displayName = 'DropdownCustomLi';
export default /*#__PURE__*/memo(DropdownCustomLi);